import React, { useRef, useEffect, useState } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

import Link from '../Link'
import DownCaret from '../../../assets/images/CarrotMD.svg'

import useWindowSize from '../../hooks/useWindowSize'

import * as styles from './index.module.css'

const HomePageHero = ({
  title,
  subtitle,
  images,
  mobileOnlyImages,
  components,
}) => {
  const rootRef = useRef(null)
  const size = useWindowSize()
  const [isPhone, setIsPhone] = useState(size.width <= 960)

  const isMobileOrTablet =
    typeof window !== 'undefined' && window.innerWidth <= 1024

  let image = images[0]
  if (isMobileOrTablet && mobileOnlyImages) {
    image = mobileOnlyImages[0]
  }

  const handleScrollDown = () => {
    const { y, height } = rootRef.current.getBoundingClientRect()
    window.scrollTo({
      behavior: 'smooth',
      left: 0,
      top: y + height,
    })
  }

  useEffect(() => {
    setIsPhone(size.width <= 960)
  }, [size.width])

  return (
    <div ref={rootRef} className={styles.homePageHero}>
      <GatsbyImage
        image={image.iphero}
        className={styles.heroImage}
        alt={image?.description}
      />
      <div
        className={isPhone ? styles.heroContainer : styles.heroDesktopContainer}
      >
        <div className={styles.heroDetails}>
          <h1 className={styles.heroTitle}>{title}</h1>
          {subtitle !== null && (
            <p className={styles.heroSubtitle}>{subtitle.subtitle}</p>
          )}
        </div>
        <div className={styles.heroActions}>
          {components !== null &&
            components.length > 0 &&
            components.map((link, index) => (
              <Link
                key={index}
                className={styles.buttonLink}
                to={link.ctaUrl}
                target="_self"
              >
                {link.ctaText}
              </Link>
            ))}
        </div>
      </div>
      <DownCaret className={styles.downCaret} onClick={handleScrollDown} />
    </div>
  )
}

export default HomePageHero
